import * as Sentry from '@sentry/remix';
import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import { startTransition, StrictMode, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

Sentry.init({
  dsn: 'https://ca1dfdba46fb97c2939f0db4b6d64c97@o4508173374652416.ingest.us.sentry.io/4508173377536000',
  tracesSampleRate: 1,
  enabled: !window.location.hostname.includes('localhost'),
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
  environment: window.ENV,
});

// Suppress hydration warnings while preserving other console output
if (typeof window !== 'undefined') {
  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    const errorMessage = args[0];

    if (typeof errorMessage === 'string') {
      const hydrationPatterns = [
        'Warning: Text content did not match',
        'Warning: Prop `',
        'Warning: Expected server HTML',
        'Hydration failed because the initial UI',
        'There was an error while hydrating',
        'Warning: validateDOMNesting',
        'Warning: An invalid form control',
      ];

      const isHydrationWarning = hydrationPatterns.some((pattern) =>
        errorMessage.includes(pattern),
      );

      if (isHydrationWarning) {
        return;
      }
    }

    originalError(...args);
  };

  console.warn = (...args) => {
    const warnMessage = args[0];

    if (typeof warnMessage === 'string') {
      const hydrationPatterns = [
        'Warning: Text content did not match',
        'Warning: Expected server HTML',
        'Hydration',
      ];

      const isHydrationWarning = hydrationPatterns.some((pattern) =>
        warnMessage.includes(pattern),
      );

      if (isHydrationWarning) {
        return;
      }
    }

    originalWarn(...args);
  };
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
